import request from '@/utils/request.js'

// 公共-获取目的地
export const getArea = function(Language) {
	return request.get('/api/global/get_area.ashx', {
		params: {
			Language,
		}
	})
}
// 公共-获取风格
export const getStyle = function(Language,SourceTable) {
	return request.get('/api/global/get_style.ashx', {
		params: {
			Language,
			SourceTable,
		}
	})
}
// 公共-出行班期
export const getSchedule = function(Language) {
	return request.get('/api/global/get_schedule.ashx', {
		params: {
			Language,
		}
	})
}
// 公共-行程天数
export const getStrokeDays = function(Language) {
	return request.get('/api/global/get_stroke_days.ashx', {
		params: {
			Language,
		}
	})
}
// 公共-套餐热门景点
export const getHotAttractions = function(Language) {
	return request.get('/api/global/get_hot_attractions.ashx', {
		params: {
			Language,
		}
	})
}
// 公共-获取酒店星级
export const getHotelStar = function(Language) {
	return request.get('/api/global/get_hotel_star.ashx', {
		params: {
			Language,
		}
	})
}
// 公共-获取酒店品牌类型
export const getHotelBrandType = function(Language) {
	return request.get('/api/global/get_brand_location.ashx', {
		params: {
			Language,
		}
	})
}
// 公共-收藏操作
export function collection(params) {
	return request.post('/api/global/collection.ashx', params)
}
// 公共-获取评论
export const getAllComments = function(PageIndex, ColumnId, DataId) {
	return request.get('/api/global/get_comment_list.ashx', {
		params: {
			PageIndex,
			ColumnId,
			DataId,
		}
	})
}

// 公共-发送邮件通知
export function sendMail(params) {
	return request.post('/api/mail/send.ashx', params)
}



/*================================用户相关================================*/
// 公共-用户注册
export const userSign = function(params) {
	return request.post('/api/global/user_sign.ashx', params)
}
// 公共-用户登录
export const userLogin = function(params) {
	return request.post('/api/global/get_token.ashx', params)
}

// 公共-退出登录
export const userLogout = function(params) {
	return request.post('/api/global/clear_token.ashx', params)
}
// 公共-检查token是否有效
export const checkToken = function(Token, Terminal) {
	return request.get('/api/global/check_token.ashx', {
		params: {
			Token,
			Terminal,
		}
	})
}
// 公共，刷新token
export const refreshToken = function(Token, Terminal) {
	return request.get('/api/global/refresh_token.ashx', {
		params: {
			Token,
			Terminal,
		}
	})
}
// 用户-获取国家
export const getCountry = function(Language) {
	return request.get('/api/global/get_country.ashx', {
		params: {
			Language,
		}
	})
}
// 用户-获取用户信息
export const getUserProfile = function(Language, Token, Terminal) {
	return request.get('/api/user/get_profile.ashx', {
		params: {
			Language,
			Token,
			Terminal,
		}
	})
}
// 用户-修改密码
export const userChangePassword = function(params) {
	return request.post('/api/user/change_password.ashx', params)
}
// 用户-修改个人信息
export const userModify = function(params) {
	return request.post('/api/user/modify.ashx', params)
}
// 用户-获取收藏列表
export const getCollect = function(Language, Token, Terminal, ColumnId, PageIndex) {
	return request.get('/api/user/get_collect.ashx', {
		params: {
			Language,
			Token,
			Terminal,
			ColumnId,
			PageIndex,
		}
	})
}
// 用户-获取普通账单类型
export const getOrderType = function(Language) {
	return request.get('/api/global/get_order_type.ashx', {
		params: {
			Language,
		}
	})
}
// 用户-获取普通账单状态
export const getOrderStatus = function(Language) {
	return request.get('/api/global/get_order_status.ashx', {
		params: {
			Language,
		}
	})
}
// 用户-获取普通账单列表
export const getOrder = function(Language, Token, Terminal, ColumnId, Status, Keyword, PageIndex) {
	return request.get('/api/user/get_order.ashx', {
		params: {
			Language,
			Token,
			Terminal,
			ColumnId,
			Status,
			Keyword,
			PageIndex,
		}
	})
}
// 用户-获取普通订单详情
export const getOrderDetail = function(Language, Token, Terminal, OrderNo) {
	return request.get('/api/user/get_order_detail.ashx', {
		params: {
			Language,
			Token,
			Terminal,
			OrderNo,
		}
	})
}
// 用户-获取协议账单列表
export const getProtocol = function(Language, Token, Terminal, PageIndex) {
	return request.get('/api/user/get_protocol_list.ashx', {
		params: {
			Language,
			Token,
			Terminal,
			PageIndex,
		}
	})
}
// 用户-获取协议订单详情
export const getProtocolDetail = function(Language, Token, Terminal, OrderNo) {
	return request.get('/api/user/get_protocol_detail.ashx', {
		params: {
			Language,
			Token,
			Terminal,
			OrderNo,
		}
	})
}



/*================================首页================================*/
// 首页-获取数据
export const getHomeData = function(Language, Terminal) {
	return request.get('/api/home/get_data.ashx', {
		params: {
			Language,
			Terminal,
		}
	})
}



/*================================套餐相关================================*/
// 套餐-获取数据列表
export const getProductList = function(Language, Area, Stroke, Sort, Keyword, PageIndex) {
	return request.get('/api/product/get_list.ashx', {
		params: {
			Language,
			Area,
			Stroke,
			Sort,
			Keyword,
			PageIndex,
		}
	})
}
// 套餐-获取详情
export const getProductDetail = function(Language, ProductId, StartDate, Terminal, Token) {
	return request.get('/api/product/get_detail.ashx', {
		params: {
			Language,
			ProductId,
			StartDate,
			Terminal,
			Token,
		}
	})
}
// 套餐-获取价格
export const getProductPrice = function(params) {
	return request.post('/api/product/get_price.ashx', params)
}
// 套餐-提交订单
export const submitProductBooking = function(params) {
	return request.post('/api/product/submit_booking.ashx', params)
}



/*================================酒店相关================================*/
// 酒店-获取数据列表
export const getHotelList = function(Language, Area, BrandType, Star, Sort, Keyword, PageIndex) {
	return request.get('/api/hotel/get_list.ashx', {
		params: {
			Language,
			Area,
			BrandType,
			Star,
			Sort,
			Keyword,
			PageIndex,
		}
	})
}
// 酒店-获取详情
export const getHotelDetail = function(Language, Terminal, HotelId, Token) {
	return request.get('/api/hotel/get_detail.ashx', {
		params: {
			Language,
			Terminal,
			HotelId,
			Token,
		}
	})
}
// 酒店-获取价格
export const getHotelPrice = function(Language, HotelId, RoomType, BeginDate, EndDate) {
	return request.get('/api/hotel/get_price.ashx', {
		params: {
			Language,
			HotelId,
			RoomType,
			BeginDate,
			EndDate,
		}
	})
}
// 酒店-提交订单
export const submitHotelBooking = function(params) {
	return request.post('/api/hotel/submit_booking.ashx', params)
}


/*================================玩乐相关================================*/
// 玩乐-获取数据列表
export const getRecreationList = function(Language, Area, Style, Sort, Keyword, PageIndex) {
	return request.get('/api/recreation/get_list.ashx', {
		params: {
			Language,
			Area,
			Style,
			Sort,
			Keyword,
			PageIndex,
		}
	})
}
// 玩乐-获取详情
export const getRecreationDetail = function(Language, Terminal, RecreationId, Token) {
	return request.get('/api/recreation/get_detail.ashx', {
		params: {
			Language,
			Terminal,
			RecreationId,
			Token,
		}
	})
}
// 玩乐-获取价格
export const getRecreationPrice = function(Language, RecreationId, BeginDate, Days) {
	return request.get('/api/recreation/get_price.ashx', {
		params: {
			Language,
			RecreationId,
			BeginDate,
			Days,
		}
	})
}
// 玩乐-提交订单
export const submitRecreationBooking = function(params) {
	return request.post('/api/recreation/submit_booking.ashx', params)
}


/*================================门票相关================================*/
// 门票-获取数据列表
export const getTicketList = function(Language, Area, Style, Sort, Keyword, PageIndex) {
	return request.get('/api/ticket/get_list.ashx', {
		params: {
			Language,
			Area,
			Style,
			Sort,
			Keyword,
			PageIndex,
		}
	})
}
// 门票-获取详情
export const getTicketDetail = function(Language, Terminal, TicketId, Token) {
	return request.get('/api/ticket/get_detail.ashx', {
		params: {
			Language,
			Terminal,
			TicketId,
			Token,
		}
	})
}
// 门票-获取价格
export const getTicketPrice = function(Language, TicketId, BeginDate, Days) {
	return request.get('/api/ticket/get_price.ashx', {
		params: {
			Language,
			TicketId,
			BeginDate,
			Days,
		}
	})
}
// 门票-提交订单
export const submitTicketBooking = function(params) {
	return request.post('/api/ticket/submit_booking.ashx', params)
}


/*================================攻略相关================================*/
// 攻略-获取分类列表
export const getGuideTypeList = function(Language) {
	return request.get('/api/guide/get_type.ashx', {
		params: {
			Language,
		}
	})
}
// 攻略-获取数据列表
export const getGuideList = function(Language, TypeId, PageIndex) {
	return request.get('/api/guide/get_list.ashx', {
		params: {
			Language,
			TypeId,
			PageIndex,
		}
	})
}
// 攻略-获取详情
export const getGuideDetail = function(Language,Id) {
	return request.get('/api/guide/get_detail.ashx', {
		params: {
			Language,
			Id,
		}
	})
}

/*================================关于我们相关================================*/
// 关于我们-获取数据列表
export const getInfoList = function(Language) {
	return request.get('/api/about/get_list.ashx', {
		params: {
			Language,
		}
	})
}
// 关于我们-获取详情
export const getInfoDetail = function(Language,Id) {
	return request.get('/api/about/get_detail.ashx', {
		params: {
			Language,
			Id,
		}
	})
}



/*================================FAQ相关================================*/
// FAQ-获取数据列表
export const getFaqList = function(Language, PageIndex) {
	return request.get('/api/faq/get_list.ashx', {
		params: {
			Language,
			PageIndex,
		}
	})
}
// FAQ-获取详情
export const getFaqDetail = function(Language, Id) {
	return request.get('/api/faq/get_detail.ashx', {
		params: {
			Language,
			Id,
		}
	})
}



/*================================搜索相关================================*/
// 搜索-获取数据列表
export const getSearchList = function(Language, Keyword, ColumnId, PageIndex) {
	return request.get('/api/search/get_data.ashx', {
		params: {
			Language,
			Keyword,
			ColumnId,
			PageIndex,
		}
	})
}